module.exports = __webpack_public_path__ + "img/symptom-b.1369bb6d.png";